// import gsap from 'gsap'
// import ScrollTrigger from 'gsap/ScrollTrigger'
// import ScrollToPlugin from 'gsap/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export class ClassPageTop {
  constructor() {
    // this.heroElem
    this.pagetopElem;
    // this.scrollBtnH = this.pagetopElem.offsetHeight;
    this.pagetopTimer;
    this.st;

    // this.startTriggerVal = "0%"
    // if (document.body.classList.contains('page-index')) {
    //   this.startTriggerVal = "25%"
    // }
    this.excute();
    // this.excute02()
  }
  // refresh = () => {
  //   this.st.refresh()
  // }
  excute = () => {
    const _this = this;

    // this.heroElem = document.querySelector('#js-hero')
    this.pagetopElem = document.querySelector("#js-page-top");

    if (this.pagetopElem) {
      this.pagetopElem.addEventListener("click", function (e) {
        e.preventDefault();
        document.body.classList.add("is-event-false");
        document.body.classList.add("is-page-top-hide");
        gsap.to(window, {
          duration: 1,
          ease: "power4.inOut", //inOut
          delay: 0,
          scrollTo: {
            y: 0,
            autoKill: false,
          },
          onComplete: () => {
            document.body.classList.remove("is-event-false");
            document.body.classList.remove("is-page-top-hide");
            // document.getElementById('page-top').focus();
          },
        });
      });
    }
  };

  // excute02 = () => {

  //   const getHeaderHeight = () => {
  //     return this.heroElem.offsetHeight
  //   }

  //   const getScrollBtnHeight = () => {
  //     return this.pagetopElem.offsetHeight
  //   }

  //   if(this.pagetopElem) {
  //     this.st = ScrollTrigger.create({
  //       trigger: '#js-main',
  //       // start: '0+=200 ' + "0%",//（triggerのY座標、ウィンドウのY座標）
  //       start:() =>  "0+=" + getHeaderHeight() + " 0%",
  //       endTrigger: '#js-contents',
  //       end: '100%+='+ getScrollBtnHeight() + ' 100%',
  //       markers: false,
  //       onEnter: () => {
  //         // if(!isHeaderMenuFlag) {
  //         if (!document.body.classList.contains('is-active-menu')) {
  //           document.body.classList.add('is-page-top-show')
  //           if(this.pagetopTimer) clearTimeout(this.pagetopTimer)
  //         }
  //       },
  //       onLeaveBack: () => {
  //           if (document.body.classList.contains('is-active-menu') || document.body.classList.contains('is-modal')) {

  //           }else {
  //             if(this.pagetopTimer) clearTimeout(this.pagetopTimer)
  //             document.body.classList.add('is-page-top-show-hide')
  //             this.pagetopTimer = setTimeout(function () {
  //               document.body.classList.remove('is-page-top-show')
  //             }, 500)
  //             setTimeout(function () {
  //               document.body.classList.remove('is-page-top-show-hide')
  //             }, 600)

  //           }
  //       },
  //       onLeave: () => {
  //         // if(!isHeaderMenuFlag) {
  //         if (!document.body.classList.contains('is-active-menu')) {
  //           // console.log("onLeave")
  //           document.body.classList.add('is-page-top-fixed')

  //         }
  //         // fixedNavElem.classList.add('is-hide')
  //       },
  //       onEnterBack: () => {
  //         // if(!isHeaderMenuFlag) {
  //         if (!document.body.classList.contains('is-active-menu')) {
  //           // console.log("onEnterBack")
  //           document.body.classList.remove('is-page-top-fixed')
  //           // gsap.set('#js-hero-inner', { top: 0 });
  //         }
  //         // fixedNavElem.classList.remove('is-hide')
  //       },
  //     })
  //   }
  // }
}

// if (document.body.classList.contains('is-active-mega') || document.body.classList.contains('is-active-barba') || document.body.classList.contains('is-modal')) {
//   return
// }
